import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Providers } from './redux/provider';
import urls from './utils/url';
import { setupAuthInterceptors } from './utils/authInterceptors';
import { clearLocalAuthState } from './utils/logout';

setupAuthInterceptors(axios, {
  refreshUrl: `${urls.DEV_URL}v1/nurse/refresh-token/`,
  publicUrls: [
    `${urls.DEV_URL}v1/nurse/login/`,
    '/api/token/consume/',
  ],
  onLogout: () => {
    clearLocalAuthState();
    window.location.replace('/');
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
  <Providers>
      <App />
    </Providers>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
